import {
  Button,
  ButtonBase,
  Card,
  CardContent,
  Container,
  Grid,
  Typography,
} from "@material-ui/core";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { ReactComponent as AgentIcon } from "assets/icons/agent-icon.svg";
import { ReactComponent as PersonalIcon } from "assets/icons/personal-icon.svg";
import { USER_ROLE } from "libs/constant/role";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { setCurrentUserRole } from "redux/modules/authSlice";
const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flex: 1,
    height: "100vh",
    justifyContent: "center",
    alignItems: "center",
    backgroundImage: `url(./assets/images/bg-login.png), linear-gradient(to bottom left, ${theme.palette.primary.main}, #00c2cb 45%, ${theme.palette.secondary.main})`,
    objectFit: "cover",
    backgroundSize: "cover",
    backgroundPosition: "50% 50%",
    backgroundRepeat: "no-repeat",
    backgroundBlendMode: "screen",
  },
  paper: {
    display: "flex",
    flexDirection: "column",
    boxShadow: "0 3px 17px 0 rgba(44, 40, 40, 0.11)",

    paddingLeft: 25,
    paddingRight: 25,
    paddingTop: 25,
    paddingButton: 45,
    flex: 1,
    borderRadius: 10,
  },
  content: {
    display: "flex",
    flexDirection: "column",
    flex: 1,
  },
  title: {
    color: "#003b5c",
  },
  submit: {
    backgroundImage: `linear-gradient(to right, ${theme.palette.secondary.main}, ${theme.palette.success.main})`,
    alignSelf: "center",
  },
  submitDisabled: {
    alignSelf: "center",
  },
  line: {
    marginTop: 8,
    height: 3,
    width: 50,
    backgroundColor: "#11cdef",
  },
  flexRow: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  wrapButton: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    margin: theme.spacing(5, 0, 4, 0),
  },
  verticalLine: {
    width: 4,
    height: 35,
    borderRadius: 4,
    backgroundColor: theme.palette.grey[300],
  },
  button: {
    padding: theme.spacing(2),
  },
  textButton: {
    marginLeft: theme.spacing(2),
  },
}));

export default function SelectRolePage() {
  const classes = useStyles();
  const theme = useTheme();
  const history = useHistory();
  const dispatch = useDispatch();
  const [active, setActive] = useState(null);

  const activeColor = theme.palette.secondary.main;
  const inActiveColor = theme.palette.grey[400];
  const getColor = (role) => (active === role ? activeColor : inActiveColor);
  const auth = useSelector((state) => state.auth);
  const isOfflineLogin = auth?.isOfflineLogin || false;
  const handleOnClickSubmit = () => {
    dispatch(setCurrentUserRole(active));

    if (active === USER_ROLE.AGENT) {
      history.replace("/personal-list");
    } else {
      history.replace("/");
    }
  };

  const isValid = [USER_ROLE.AGENT, USER_ROLE.USER].includes(active);
  const handleLogout = () => {
    if (isOfflineLogin) {
      history.replace("/logout");
    } else {
      history.replace("/logout");
      // logoutRedirect();
    }
  };
  return (
    <div className={classes.root}>
      <Container maxWidth="sm">
        <Card className={classes.paper}>
          <CardContent className={classes.content}>
            <Typography variant="h4" className={classes.title}>
              Choose
            </Typography>
            <div className={classes.line} />
            <div className={classes.wrapButton}>
              <ButtonBase
                onClick={() => setActive(USER_ROLE.USER)}
                className={classes.button}
              >
                <div className={classes.flexRow}>
                  <PersonalIcon
                    fill={getColor(USER_ROLE.USER)}
                    stroke={getColor(USER_ROLE.USER)}
                  />
                  <Typography
                    variant="h4"
                    className={classes.textButton}
                    style={{ color: getColor(USER_ROLE.USER) }}
                  >
                    Personal
                  </Typography>
                </div>
              </ButtonBase>
              <div className={classes.verticalLine} />
              <ButtonBase
                onClick={() => setActive(USER_ROLE.AGENT)}
                className={classes.button}
              >
                <div className={classes.flexRow}>
                  <AgentIcon fill={getColor(USER_ROLE.AGENT)} />
                  <Typography
                    variant="h4"
                    className={classes.textButton}
                    style={{ color: getColor(USER_ROLE.AGENT) }}
                  >
                    Agency
                  </Typography>
                </div>
              </ButtonBase>
            </div>
            <Grid
              container
              spacing={0}
              direction="column"
              alignItems="center"
              justifyContent="center"
            >
              <div className={classes.flexRow}>
                <Button
                  variant="contained"
                  size="large"
                  onClick={() => handleLogout()}
                  style={{
                    marginRight: 15,
                    backgroundColor: "red",
                    color: "white",
                    width: "100%",
                    height: 50,
                  }}
                >
                  Logout
                </Button>
                <Button
                  variant="contained"
                  color="secondary"
                  size="large"
                  className={isValid ? classes.submit : classes.submitDisabled}
                  onClick={handleOnClickSubmit}
                  disabled={!isValid}
                  style={{
                    width: "100%",
                    height: 50,
                  }}
                >
                  Submit
                </Button>
              </div>
            </Grid>
          </CardContent>
        </Card>
      </Container>
    </div>
  );
}
